function initGlytoneFaq(root) {
  if (!root || root.dataset.faqInitialized === 'true') return;

  root.dataset.faqInitialized = 'true';

  const triggers = root.querySelectorAll('[data-faq-trigger]');

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      const panelId = trigger.getAttribute('aria-controls');
      const panel = root.querySelector(`#${CSS.escape(panelId)}`);

      triggers.forEach((otherTrigger) => {
        const otherPanelId = otherTrigger.getAttribute('aria-controls');
        const otherPanel = root.querySelector(`#${CSS.escape(otherPanelId)}`);

        otherTrigger.setAttribute('aria-expanded', 'false');
        otherPanel?.classList.remove('is-open');
      });

      if (!isOpen) {
        trigger.setAttribute('aria-expanded', 'true');
        panel?.classList.add('is-open');
      }
    });
  });
}

function initAllGlytoneFaqs(scope = document) {
  scope.querySelectorAll('[data-glytone-faq]').forEach(initGlytoneFaq);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initAllGlytoneFaqs();
  });
} else {
  initAllGlytoneFaqs();
}

document.addEventListener('shopify:section:load', (event) => {
  initAllGlytoneFaqs(event.target);
});